import {
  UPDATE_LANGUAGE,
  UPDATE_FORM,
  UPDATE_FIELD,
  UPDATE_SECTION,
  HIDE_BUTTON,
  UPDATE_CAPTCHA_STATUS,
  SET_LOADER,
  REMOVE_ERROR,
  CUSTOM_ERROR,
  UPDATE_SHOW_SECTION,
} from '../contants/action-types';
import axios from 'axios';
import config from '../../../../../src/temp/config';

export function updateFields(payload) {
  return { type: UPDATE_LANGUAGE, payload: payload };
}

export function setLoader(payload) {
  return { type: SET_LOADER, payload: payload };
}
export function updateRemoveError(payload) {
  return { type: REMOVE_ERROR, payload: payload };
}

export function updateCustomError(payload) {
  return { type: CUSTOM_ERROR, payload: payload };
}

export function updateHideButton(payload) {
  return { type: HIDE_BUTTON, payload: payload };
}

export function updateConditionalRederingData(payload) {
  return { type: UPDATE_FORM, payload: payload };
}

export function UpdateConditionalFieldValue(payload) {
  return { type: UPDATE_FIELD, payload: payload };
}

export function UpdateConditionalSectionControls(payload) {
  return { type: UPDATE_SECTION, payload: payload };
}

export function getLayoutServiceData(dispatch, culture) {
  // let url = config.sitecoreApiHost + "api/formdata/en/" + culture + "/" + config.jssAppName + "/Privacy%20Form?sc_apikey=" +  config.sitecoreApiKey;
  //let url = "https://eucomcrg04-123710-cm.azurewebsites.net/api/formdata/en/" + culture + "/" + config.jssAppName + "/Privacy%20Form?sc_apikey=" +  config.sitecoreApiKey;

  let url =
    '/api/formdata/en/' +
    culture +
    '/' +
    config.jssAppName +
    '/Privacy%20Form?sc_apikey=' +
    config.sitecoreApiKey;
  axios
    .get(url)
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      let newfeilds = data.fields;
      dispatch(updateFields(newfeilds));
    });
}

export function UpdateCaptchaStatus(payload) {
  return { type: UPDATE_CAPTCHA_STATUS, payload: payload };
}

export function UpdateShowSectionStatus(payload) {
  return { type: UPDATE_SHOW_SECTION, payload: payload };
}
